import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import "@/index.css";
import App from "@/App";
import ClerkRoot from "@/components/ClerkRoot";
import { AuthProvider } from "@/context/AuthContext";
import ClerkSessionBridge from "@/components/ClerkSessionBridge";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem storageKey="faanuu-theme">
      <QueryClientProvider client={queryClient}>
        <ClerkRoot>
          <AuthProvider>
            <ClerkSessionBridge />
            <App />
          </AuthProvider>
        </ClerkRoot>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
